import { useSocket } from '../contexts/SocketContext';

export function ConnectionBanner() {
  const { isConnected, hasConnected } = useSocket();

  // Only show when disconnected after having previously connected
  if (isConnected || !hasConnected) return null;

  return (
    <div className="connection-banner" role="alert">
      Reconnecting...
    </div>
  );
}
